import { autoinject, customAttribute } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { watch } from 'aurelia-watch-decorator';
import { SortController, SortInstruction, SortOrder } from 'framework/aurelia_tools/sort-controller';

@autoinject
@customAttribute('af-sort-column')
export class SortColumnCustomAttribute {
  private element: HTMLTableHeaderCellElement;
  @bindable({ primaryProperty: true }) expression: string;
  @bindable mode: 'css' | 'html' = 'html';
  originalContent: string;

  constructor(element: Element, private sortController: SortController) {
    this.element = element as HTMLTableHeaderCellElement;
  }

  attached() {
    this.element.classList.add(CLASS_COMPONENT, CLASS_MODE.replace('{mode}', this.mode));
    this.applyInstruction(this.sortController.instruction);

    if (this.mode === 'html') {
      this.originalContent = this.element.innerHTML;
      this.element.innerHTML = `<div class="__container"><div class="__content">${this.originalContent}</div><div class="__indicator" /></div>`;
    }

    this.element.addEventListener('click', this.handleClick);
  }

  detached() {
    this.element.removeEventListener('click', this.handleClick);

    if (this.mode === 'html')
      this.element.innerHTML = this.originalContent;

    this.element.classList.remove(CLASS_COMPONENT, CLASS_MODE.replace('{mode}', this.mode), CLASS_ASCENDING, CLASS_DESCENDING, CLASS_OTHER);
  }

  handleClick = (e: MouseEvent) => {
    e.preventDefault();
    this.sortController.toggleColumn(this.fullExpression);
    return false;
  }

  @watch((x: SortColumnCustomAttribute) => x.sortController.instruction)
  private applyInstruction(instruction: SortInstruction) {
    const settleClasses = (add: string[], remove: string[]) => {
      this.element.classList.remove(...remove);
      this.element.classList.add(...add);
    };

    if (instruction?.request?.column !== this.fullExpression)
      this.element.classList.remove(CLASS_ASCENDING, CLASS_DESCENDING, CLASS_OTHER);

    else
      switch (instruction?.request?.order) {
        case SortOrder.Ascending: settleClasses([CLASS_ASCENDING], [CLASS_DESCENDING, CLASS_OTHER]); break;
        case SortOrder.Descending: settleClasses([CLASS_DESCENDING], [CLASS_ASCENDING, CLASS_OTHER]); break;
        default: settleClasses([CLASS_OTHER], [CLASS_ASCENDING, CLASS_DESCENDING]);
      }
  }

  get fullExpression() {
    return this.expression.includes('?') ? this.expression.trim() : `${this.expression.trim()} ?`;
  }
}

const CLASS_COMPONENT = 'af-sort-column';
const CLASS_MODE = 'af-sort-column--{mode}';
const CLASS_ASCENDING = 'af-sort-column--ascending';
const CLASS_DESCENDING = 'af-sort-column--descending';
const CLASS_OTHER = 'af-sort-column--other';
